/**
 * Top ヘッダースライダー
 */
!function(){
	var $slider = $('.js-top-header-slider');
	if($slider.length !== 0){
		$slider.slick({
			dots: true,
			arrows:true,
			infinite: true,
			speed: 500,
			centerPadding: '75px',
			slidesToShow: 3,
			slidesToScroll: 1,
			autoplay: true,
			autoplaySpeed: 5000,
			centerMode:true,
			prevArrow: '<span class="slick-prev slick-arrow"><i class="fas fa-chevron-left"></i></span>',
			nextArrow: '<span class="slick-next slick-arrow"><i class="fas fa-chevron-right"></i></span>',
			responsive: [
				{
					breakpoint: 751,
					settings: {
						slidesToShow: 1,
					}
				},
				{
					breakpoint: 415,
					settings: {
						slidesToShow: 1,
						centerPadding: '40px',
					}
				},
			]
		});
	}
}();

/**
 * イベントアーカイブ スライダー
 */
const $eventArchiveSlider = $('.js-event-archive-slider');
if($eventArchiveSlider.length !== 0){
	$eventArchiveSlider.slick({
		dots: true,
		arrows:true,
		infinite: true,
		speed: 500,
		centerPadding: '0',
		slidesToShow: 3,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 5000,
		centerMode:true,
		prevArrow: '<span class="slick-prev slick-arrow"><i class="fas fa-chevron-left"></i></span>',
		nextArrow: '<span class="slick-next slick-arrow"><i class="fas fa-chevron-right"></i></span>',
		responsive: [
			{
				breakpoint: 751,
				settings: {
					slidesToShow: 1,
					//autoplaySpeed: 50000,
				}
			},
			{
				breakpoint: 415,
				settings: {
					slidesToShow: 1,
					centerPadding: '40px',
				}
			},
		]
	});
}


/**
 * ホテルスライダー　画面幅
 */
const $hotelFullSlider = $('.js-slider-hotel-full');
if($hotelFullSlider.length !== 0){
	$hotelFullSlider.slick({
		dots: true,
		arrows:true,
		infinite: true,
		speed: 500,
		centerPadding: '0',
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 5000,
		centerMode:true,
		prevArrow: '<span class="slick-prev slick-arrow"><i class="fas fa-chevron-left"></i></span>',
		nextArrow: '<span class="slick-next slick-arrow"><i class="fas fa-chevron-right"></i></span>',
		responsive: [
			{
				breakpoint: 751,
				settings: {
					slidesToShow: 1,
					slidesToShow: 1,
					//autoplaySpeed: 50000,
				}
			},
			{
				breakpoint: 415,
				settings: {
					slidesToShow: 1,
					centerPadding: '40px',
				}
			},
		]
	});
}


/**
 * ホテルスライダー
 */
const $sliderHotel = $('.js-slider-hotel');
if($sliderHotel.length !== 0){
	$sliderHotel.slick({
		dots: true,
		arrows:true,
		infinite: true,
		speed: 500,
		centerPadding: '0',
		slidesToShow: 3,
		slidesToScroll: 1,
		//autoplay: true,
		autoplaySpeed: 5000,
		centerMode:true,
		prevArrow: '<span class="slick-prev slick-arrow"><i class="fas fa-chevron-left"></i></span>',
		nextArrow: '<span class="slick-next slick-arrow"><i class="fas fa-chevron-right"></i></span>',
		responsive: [
			{
				breakpoint: 751,
				settings: {
					slidesToShow: 1,
					slidesToShow: 1,
					//autoplaySpeed: 50000,
				}
			},
		]
	});
}

/**
 * ホテルスライダー　サムネイル連携
 */
!function(){
	var $slider = $('.js-slider-hotel-thum');
	var $thumSlider = $('.js-slider-hotel-thum-btn');
	if($slider.length !== 0 && $thumSlider.length !== 0){
		$slider.slick({
			dots: false,
			arrows:true,
			infinite: true,
			speed: 500,
			centerPadding: '0',
			slidesToShow: 3,
			slidesToScroll: 1,
			autoplay: true,
			autoplaySpeed: 5000,
			centerMode:true,
			prevArrow: '<span class="slick-prev slick-arrow"><i class="fas fa-chevron-left"></i></span>',
			nextArrow: '<span class="slick-next slick-arrow"><i class="fas fa-chevron-right"></i></span>',
			asNavFor: '.js-slider-hotel-thum-btn',
			responsive: [
				{
					breakpoint: 751,
					settings: {
						slidesToShow: 1,
						//autoplaySpeed: 50000,
					}
				},
				{
					breakpoint: 415,
					settings: {
						slidesToShow: 1,
						centerPadding: '40px',
					}
				},
			]
		});
		$thumSlider.slick({
			dots: false,
			arrows:false,
			infinite: true,
			speed: 500,
			centerPadding: '0',
			slidesToShow: 6,
			slidesToScroll: 1,
			//autoplay: true,
			autoplaySpeed: 5000,
			centerMode:true,
			asNavFor: '.js-slider-hotel-thum',
			focusOnSelect: true,
			responsive: [
				{
					breakpoint: 751,
					settings: {
						slidesToShow: 100,
					}
				},
			]
		});
	}
}();


/**
 * イベント会場ページ スライダー
 */
const $rentalSlider = $('.js-rental-slider');
if($rentalSlider.length !== 0){
	$rentalSlider.slick({
		dots: true,
		arrows:true,
		infinite: true,
		speed: 500,
		centerPadding: '0',
		slidesToShow: 3,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 5000,
		centerMode:true,
		prevArrow: '<span class="slick-prev slick-arrow"><i class="fas fa-chevron-left"></i></span>',
		nextArrow: '<span class="slick-next slick-arrow"><i class="fas fa-chevron-right"></i></span>',
		responsive: [
			{
				breakpoint: 751,
				settings: {
					slidesToShow: 1,
					//autoplaySpeed: 50000,
				}
			},
			{
				breakpoint: 415,
				settings: {
					slidesToShow: 1,
				}
			},
		]
	});
}

/**
 * 活用例スライダー
 */
const $usageSlider = $('.js-slider-usage');
if($usageSlider.length !== 0 && $usageSlider.children().length > 1){
	$usageSlider.slick({
		dots: false,
		arrows:true,
		infinite: true,
		speed: 500,
		centerPadding: '0',
		slidesToShow: 4,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 5000,
		centerMode:true,
		prevArrow: '<span class="slick-prev slick-arrow"><i class="fas fa-chevron-left"></i></span>',
		nextArrow: '<span class="slick-next slick-arrow"><i class="fas fa-chevron-right"></i></span>',
		responsive: [
			{
				breakpoint: 751,
				settings: {
					slidesToShow: 1,
					slidesToShow: 1,
					//autoplaySpeed: 50000,
				}
			},
		]
	});
} else {
	$usageSlider.removeClass('js-slider-usage');
}